module.exports = __webpack_public_path__ + "static/media/imagen_tips.48666282.png";